import { Check, X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function Compare() {
  const t = useT();
  const { COMPARISON } = useContent();

  return (
    <section data-testid="comparison-section" className="bg-ink py-24 md:py-32">
      <div className="container-site">
        <Chapter n={6} label={t['ch.compare']} />
        <FadeUp>
          <h2 className="max-w-2xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['cp.h2a']} <span className="italic text-gold">{t['cp.h2b']}</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.1}>
          <div className="mt-12 overflow-hidden rounded-xl border border-white/10">
            <table data-testid="comparison-table" className="w-full text-left">
              <thead>
                <tr className="border-b border-white/10 bg-coal">
                  <th className="px-5 py-4 text-xs font-bold uppercase tracking-[0.2em] text-silver md:px-8">{t['cp.col1']}</th>
                  <th className="px-5 py-4 text-xs font-bold uppercase tracking-[0.2em] text-gold md:px-8">Reverence</th>
                  <th className="px-5 py-4 text-xs font-bold uppercase tracking-[0.2em] text-silver md:px-8">{t['cp.col3']}</th>
                </tr>
              </thead>
              <tbody>
                {COMPARISON.map((r) => (
                  <tr key={r.label} className="border-b border-white/5 transition-colors last:border-0 hover:bg-white/[0.03]">
                    <td className="px-5 py-4 text-sm font-semibold text-white md:px-8">{r.label}</td>
                    <td className="px-5 py-4 md:px-8">
                      <span className="flex items-center gap-2 text-sm text-white"><Check className="h-4 w-4 shrink-0 text-gold" /> {r.us}</span>
                    </td>
                    <td className="px-5 py-4 md:px-8">
                      <span className="flex items-center gap-2 text-sm text-silver"><X className="h-4 w-4 shrink-0 text-silver/50" /> {r.them}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FadeUp>
        <FadeUp delay={0.15} className="mt-10">
          <Link data-testid="comparison-cta" to="/quote" className="gold-btn">
            {t['cp.cta']} <ArrowRight className="h-4 w-4" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
